/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BillingEventActionEnum = 'ENABLE_BILLING' | 'DISABLE_BILLING';

export const BillingEventActionEnum = {

    ENABLE_BILLING: 'ENABLE_BILLING' as BillingEventActionEnum,

    DISABLE_BILLING: 'DISABLE_BILLING' as BillingEventActionEnum
};

